import { createStyles, makeStyles } from "@material-ui/core";

import { baseColors, RelodeTheme } from "../../..";

export const useMarketResearchSummaryStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexGrow: 1,
                flexDirection: "column",
            },
            addIcon: {
                marginRight: theme.spacing(1),
            },
            addContainer: {
                marginBottom: theme.spacing(2),
            },
            tilesSectionPaper: {
                [theme.breakpoints.up("md")]: {
                    display: "flex",
                },
            },
            tilesSection: {
                display: "flex",
                placeItems: "flex-start",
                padding: "8px 16px 8px 16px",
                marginBottom: "16px",
            },
            sectionWrapper: {
                padding: "32px 0px 32px 0px",
            },
            statusTile: {
                flexGrow: 1,
                marginTop: theme.spacing(1),
                [theme.breakpoints.up("md")]: {
                    marginTop: 0,
                },
                minWidth: "130px",
            },
            statusContent: {
                color: baseColors.navy,
                margin: 0,
                fontFamily: [
                    // eslint-disable-next-line quotes
                    '"hkgrotesk_bold"',
                    "Helvetica",
                    "sans-serif",
                ].join(","),
            },
            statusTitle: {
                color: baseColors.light_black,
                fontSize: "1rem",
                fontFamily: [
                    // eslint-disable-next-line quotes
                    '"hkgrotesk_regular"',
                    "Helvetica",
                    "sans-serif",
                ].join(","),
            },
            tilePaper: {
                height: "100px",
                minWidth: "100px",
            },
            funnelTitle: {
                marginBottom: theme.spacing(3),
            },
            section: {
                display: "flex",
                flexDirection: "column",
                marginTop: theme.spacing(10),
            },
            mobileSection: {
                display: "flex",
                flexDirection: "column",
                marginTop: theme.spacing(4),
            },
            marketHeader: {
                padding: theme.spacing(6, 1),
                backgroundColor: baseColors.warm_gray,
                display: "grid",
                gridTemplateColumns: "auto 1fr",
                columnGap: theme.spacing(1),
                alignItems: "left",
                marginBottom: theme.spacing(2),
            },
            mobileHeader: {
                padding: theme.spacing(2, 1),
                backgroundColor: baseColors.warm_gray,
                alignItems: "center",
                marginBottom: theme.spacing(1),
            },
            icon: {
                marginLeft: theme.spacing(4),
                "& svg": {
                    verticalAlign: "text-top",
                },
            },
            displayContent: {
                display: "flex",
                flexDirection: "row",
                flexFlow: "wrap",
            },
            displayFlex: {
                display: "flex",
                columnGap: "24px",
                alignItems: "center",
                [theme.breakpoints.down("sm")]: {
                    display: "block",
                },
            },
            displayFlexError: {
                display: "flex",
                columnGap: "6px",
            },
            summaryError: {
                padding: theme.spacing(0.6, 4),
            },
            unlinkedSummaryTitle: {
                color: baseColors.magenta,
            },
        }),
    { name: "MarketResearchSummary" }
);
